import { MersetaDelete } from "../../Model/Dto/WSP/MerSetaDelete";
import { ActionType, TableColumn } from "../../Model/Table/Table";
import { ActionsCell } from "./DataTable/ActionsCell";
import { DefaultCell } from "./DataTable/DefaultCell";

interface MersetaDeleteTrainingRows {
    courseName: string,
    startEndDate: string,
    association: string,
    actions: ActionType[];
}

interface MersetaDeleteTrainingTable {
    columns: Array<TableColumn>;
    rows: Array<MersetaDeleteTrainingRows>;
}

export function WarningDialogTableMapper(dataObject: MersetaDelete[], handleLinkClick: (trainingType: string, associationType: string, id: number) => void): MersetaDeleteTrainingTable {
    const columns = [
        { Header: 'Course Name', accessor: 'courseName', id: 'courseName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />, disableSortBy: true },
        { Header: 'Start - End Date', accessor: 'startEndDate', id: 'startEndDate', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Association', accessor: 'association', id: 'association', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: MersetaDelete, index: number) => ({
            courseName: item.courseName,
            startEndDate: item.startEndDate,
            association: item.association,
            actions: [{
                key: index.toString(),
                label: 'Link',
                action: () => {
                    handleLinkClick(item.trainingType, item.association, item.setaId);
                },
                icon: {
                    color: 'info',
                    name: 'launch'
                }
            },]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
